/* 曹操傳・第 7 章：白馬・延津（建安五年，200）
 * 史實：《三國志·關羽傳》曹操使張遼、關羽為先鋒救白馬，「羽望見良麾蓋，策馬刺良於萬衆之中，斬其首還，紹諸將莫能當者」。
 *       《武帝紀》：延津，曹操令騎兵解鞍放馬，把輜重擺在路上；「紹騎將文醜與劉備將五六千騎前後至」，諸將說敵騎多，不如回營，
 *       荀攸說「此所以餌敵，如何去之」；敵騎爭搶輜重，「騎不滿六百，遂縱兵擊，大破之，斬醜」。
 * 流程：1. 白馬：操作張遼。關羽直取顏良，擋在他前面的袁兵會攔住他；替關羽清出一條路，他就會斬顏良。
 *       2. 延津：輜重擺在南坂下，文醜的騎兵來搶。在南坂上等，敵騎散開搶輜重的人多了再衝下去；太早衝，敵陣還整齊。斬文醜即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, TROOPS, PEOPLE, rout, vanish } from '../kit.ts';
import { YAN, BAIT, SLOPE, WEN } from '../maps/baima.ts';

const LV = 11, START = [1600, 2400];
const YUAN = { spec: TROOPS.yuan, name: '袁軍', hp: 460, maxHp: 460, atk: 26 };
const RIDER = { spec: TROOPS.yuan, name: '袁騎', hp: 480, maxHp: 480, atk: 28, ms: 270 };

export default {
  id: 'caocao-7', map: 'baima', hero: 'zhangliao',
  title: '第 7 章　白馬・延津', year: '建安五年（200）',
  brief: {
    quote: [{ text: '羽望見良麾蓋，策馬刺良於萬衆之中，斬其首還，紹諸將莫能當者。', src: '《三國志·蜀書·關羽傳》' }],
    text: '袁紹派顏良圍白馬。曹操聲東擊西，引開袁紹主力，以張遼、關羽為先鋒急救白馬。這時關羽暫在曹營。',
    goals: ['替關羽清出一條路，讓他直取顏良', '在延津南坂誘敵，看準時機衝擊', '斬文醜'],
  },
  words: { ally: '曹軍', foe: '袁軍' },
  stars: [
    { text: '40 秒內讓關羽斬顏良', ok: (m) => m.vars.yanT != null && m.vars.yanT < 40 },
    { text: '如史：等敵騎散開搶輜重（6 騎以上）才衝擊', ok: (m) => !!m.vars.goodCharge },
    { text: '親手斬文醜', ok: (m) => !!m.vars.wenMine },
  ],
  steps: [
    { // 1. 白馬：替關羽開路
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        V.t0 = w.t;
        V.guan = ally(w, 'guanyu', START[0] - 100, START[1] + 120, LV + 1);
        V.yan = boss(w, PEOPLE.yanliang, YAN[0], YAN[1], { name: '顏良', hp: 4000, atk: 50, armor: 8 });
        // 顏良的陣：擋在路上的三排袁兵
        V.wall = [];
        for (let r = 0; r < 3; r++) for (let i = 0; i < 5; i++) { const u = m.foe('huangjin', YAN[0] - 1300 + r * 380, YAN[1] - 320 + i * 160, YUAN); u.home = [u.x, u.y]; V.wall.push(u); }
        m.line('關羽', '那插著麾蓋的，就是顏良吧。');
        m.after(2.5, () => m.line('張遼', '雲長，我替你開路！'));
        m.after(5, () => m.line('提示', '關羽會直取顏良，但路上的袁兵會攔住他。殺開他前面的袁兵，讓他衝過去。'));
        m.mark('yan', YAN[0], YAN[1], '顏良麾蓋', false, V.yan);
        m.obj('yan', '替關羽清出一條路，直取顏良');
      },
      tick(m, w) {
        const V = m.vars, g = V.guan, yan = V.yan;
        // 關羽：一路往顏良衝；前方 160 內有袁兵就停下來打
        const block = V.wall.find((u) => u.alive && SG.gd(u.x, u.y, g.x, g.y) < 160);
        if (block) { g.input.moveTo = null; g.input.target = block; g.input.engage = true; }
        else { g.input.target = null; g.input.engage = false; g.input.moveTo = [yan.x, yan.y]; }
        if (yan.alive && SG.gd(g.x, g.y, yan.x, yan.y) < 140) {
          yan.hp = 0; w.kill(g, yan); w.fx({ k: 'spark', x: yan.x, y: yan.y - 40, col: '#ffe0a0' });
        }
        return !yan.alive;
      },
    },
    { // 2. 斬其首還：轉往延津
      enter(m, w) {
        const V = m.vars;
        V.yanT = w.t - V.t0;
        m.done('yan'); m.unmark('yan');
        m.big('斬顏良！');
        m.card('策馬刺良於萬衆之中，斬其首還，紹諸將莫能當者。', '《關羽傳》');
        rout(m, w, V.wall, [8400, 2400]);
        m.after(3, () => { m.line('曹操', '袁紹的騎兵追來了。把輜重擺在南坂下的路上，騎兵解鞍放馬。'); vanish(w, V.guan); });
        // 輜重
        V.carts = [[-160, -60], [0, 40], [160, -40], [-80, 160], [120, 180]].map(([dx, dy]) => m.folk(BAIT[0] + dx, BAIT[1] + dy, { name: '輜重', still: true, near: 1, draw: wagon }));
        m.mark('slope', SLOPE[0], SLOPE[1], '南坂');
        m.obj('slope', '到南坂上埋伏');
      },
      tick(m, w) { return m.near(w.player, SLOPE[0], SLOPE[1], 260); },
    },
    { // 3. 延津：等敵騎散開搶輜重
      enter(m, w) {
        const V = m.vars;
        m.done('slope'); m.unmark('slope');
        m.line('諸將', '敵騎太多了，不如回營吧？');
        m.after(2.5, () => m.line('荀攸', '此所以餌敵，如何去之！'));
        m.after(5, () => m.line('提示', '敵騎會停下來搶輜重。搶的人越多，陣形越亂；看準了再衝下去打。'));
        V.wen = boss(w, PEOPLE.wenchou, WEN[0], WEN[1], { name: '文醜', hp: 3000, atk: 46, armor: 8, ms: 250 });
        V.wen.home = [BAIT[0] + 300, BAIT[1]];
        V.riders = Array.from({ length: 12 }, (_, i) => { const u = m.foe('huangjin', WEN[0] - 200 + (i % 4) * 80, WEN[1] - 200 + Math.floor(i / 4) * 120, RIDER); u.home = V.carts[i % V.carts.length].home.slice(); u.loot = 0; return u; });
        m.obj('loot', '');
        V.t3 = w.t;
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        // 在輜重旁停下來的騎兵：搶得越久越散
        let looting = 0;
        for (const u of V.riders) if (u.alive && V.carts.some((c) => SG.gd(c.x, c.y, u.x, u.y) < 120)) { u.loot += dt; if (u.loot > 1.5) looting++; }
        if (!V.charged) m.get('loot').text = `敵騎在搶輜重：${looting} 騎（6 騎以上再衝）`;
        // 衝下去：張遼打到任何一個敵騎或文醜，就算衝擊
        const hit = V.riders.concat(V.wen).some((u) => u.dmgBy && u.dmgBy[me.id] > V.t3);
        if (hit && !V.charged) {
          V.charged = true; V.goodCharge = looting >= 6; m.done('loot');
          // 縱兵擊：坂上的曹騎一起衝下來
          for (let i = 0; i < 8; i++) { const p = SG.MAP.nearestFree(SLOPE[0] - 60 + (i % 4) * 50, SLOPE[1] + 80 + Math.floor(i / 4) * 60); const u = m.recruit(p[0], p[1], '曹騎'); u.spec = TROOPS.wei; u.ms = 300; m.join(u, me); }
          if (V.goodCharge) rout(m, w, m.alive(V.riders).filter((_, i) => i % 2), [8800, 3400]); // 搶輜重搶亂了：一半的人丟下東西就跑
          if (V.goodCharge) { m.big('縱兵擊之！'); for (const u of m.alive(V.riders)) w.addBuff(u, { id: '搶輜重', t: 12, neg: true, ms: -0.3, atkP: -0.3 }); m.line('張遼', '敵騎亂了！殺！'); }
          else { m.line('張遼', '衝早了，敵陣還整齊！'); for (const u of m.alive(V.riders)) w.addBuff(u, { id: '列陣', t: 10, atkP: 0.2 }); }
          m.obj('wen', '斬文醜');
        }
        if (V.charged && !V.wen.alive) { V.wenMine = V.wen.dmgBy && V.wen.dmgBy[me.id] > w.t - 3; return true; }
        return false;
      },
    },
    { // 4. 斬醜
      enter(m, w) {
        const V = m.vars;
        m.done('wen');
        m.card('騎不滿六百，遂縱兵擊，大破之，斬醜。', '《武帝紀》');
        rout(m, w, V.riders, [8800, 3400]);
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('張遼陣亡'); return; }
    const g = m.vars.guan;
    if (g && !g.alive) { m.lose('關羽陷在陣中'); return; }
  },
};

// 輜重車：擺在路上當誘餌
function wagon(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 4, 54, 12, 80, 0.3);
  poly(ctx, [[-48, -12], [48, -12], [48, -30], [-48, -30]], '#7a5634', 2);
  for (const x of [-30, 30]) { ctx.beginPath(); ctx.arc(x, -6, 13, 0, Math.PI * 2); SG.draw.ink(ctx, '#4a3424', 2); }
  poly(ctx, [[-42, -30], [-4, -30], [-6, -56], [-40, -56]], '#c9b07a', 1.6);
  poly(ctx, [[2, -30], [42, -30], [38, -50], [6, -50]], '#a07848', 1.6);
  ctx.fillStyle = '#e0c060'; ctx.beginPath(); ctx.arc(24, -54, 6, 0, Math.PI * 2); ctx.fill();
  ctx.restore();
}
